import React from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { DatePickerTextField } from '../../ui/DatePickerTextField'
import { Box, TextField, useTheme } from '@mui/material'

/**
 * Renders a customizable `DatePicker` component
 * @param {Object}  - object containing relevant data to render the element
 * @param {string} label - Text label for the DatePicker
 * @param {string} dateField - Name of the date field in the objectData context
 * @returns {JSX.Element} DatePicker MUI
 */

const CustomDatePicker = ({ objectData, label, dateField, isDirty = false, onChange, isReadOnlyRender = false }) => {
  const theme = useTheme()
  const startDate = objectData[dateField]
  const daysSince = startDate ? dayjs().diff(dayjs(startDate), 'day') : 0

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display='flex' gap={2} alignItems='center'>
        <DatePicker
          // label={label}
          label={''}
          value={startDate ? dayjs(startDate) : null}
          onChange={newValue => onChange(dateField, newValue?.toISOString?.())}
          slots={{
            textField: DatePickerTextField,
          }}
          slotProps={{ textField: { isDirty: isDirty, isReadOnlyRender: isReadOnlyRender } as any }}
        />
        <TextField
          label='Tenure'
          value={startDate ? daysSince : 0}
          InputProps={{ readOnly: true }}
          variant='outlined'
          size='small'
          sx={{ width: 150, '& .MuiInputBase-root': { bgcolor: isDirty ? 'text.dirty' : 'background.input' } }}
        />
      </Box>
    </LocalizationProvider>
  )
}

export default CustomDatePicker
